import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { state_array } from "../../variables/Variables";

export default function State(props) {
  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>

        <Form.Control
          required
          as="select"
          className="form-control"
          value={props.state[props.id] ? props.state[props.id] : ""}
          onChange={props.onChange}
          name={props.id}
          isInvalid={props.isInvalid}
          data-hj-allow
        >
          <option value="">{props.placeholder ? props.placeholder : "Select a state"}</option>
          {Object.keys(state_array).map((prop, key) => {
            return (
              <option key={key} value={prop}>
                {state_array[prop]}
              </option>
            );
          })}
        </Form.Control>
        <Form.Control.Feedback type="invalid">Please select State.</Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
